import { render, staticRenderFns } from "./DeliveryOptions.vue?vue&type=template&id=b84e628a&"
import script from "./DeliveryOptions.vue?vue&type=script&lang=js&"
export * from "./DeliveryOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports